export const loginStatus = {
  LOADED: 'loginStatus.loaded'
}
